module.exports = __webpack_public_path__ + "img/06.8eee4795.png";